export default __webpack_public_path__ + "static/media/twitter.2a9f5581.svg";